import { Injectable } from '@angular/core';
import { SegmentService } from '@ispm-client/modules/segments/services/segments.service';
import { isEmpty, head } from 'lodash';
import { Icontext } from '@ispm-client/modules/aggregator/interfaces';

@Injectable()
export class FindingsService {

  private static UNIQUE_ID: string = '__gen-selection-list__unique-item-id__';

  constructor(private segmentService: SegmentService) {

  }

  addContext(dataBindings, item: any) {
    const _context: Array<Icontext> = [];
    if (!isEmpty(dataBindings)) {
     const  contextBindings = dataBindings.filter(binding => binding.hasOwnProperty('responseUsed')
        && binding['responseUsed'] === 'context');
     this.segmentService.fetchDataBasedOnPriority(contextBindings, 1, { })
       .filter(data => !isEmpty(data))
       .subscribe(data => {
       contextBindings.forEach(contextBinding => {
         _context.push({ reference: data.id,
           resourceType: contextBinding['targetResource']});
       });
       item['context'] = _context;
     });

    }
  }

  cloneContextForAddItem(data: any[] , newItem: any) {
    const item = head(data);
    newItem['context'] = item['context'];
  }


}
